import React from 'react';
import { ShieldCheckIcon, CheckIcon, ClockIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const logros = ['Diseñar decoraciones desde cero', 'Armar arcos, columnas y guirnaldas', 'Presupuestar y conseguir clientes', 'Convertir tu habilidad en ingresos'];
export function CtaFinal() {
  return <section id="inscribirme" className="w-full bg-[#2f2a33] py-24" data-id="element-13" data-mp="on9wnzadiu4i">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-14" data-mp="vur7xnavwp1">
        <Reveal data-id="element-15" data-mp="ygxltygg65o">
          <span className="inline-flex items-center gap-2 rounded-full bg-[#ec4899]/15 px-4 py-1.5 text-sm font-semibold text-[#f9a8d4]" data-id="element-16" data-mp="3s2nqux2g3nrg">
            <ClockIcon className="h-4 w-4" data-id="element-17" data-mp="9y3xucfg75x5" />
            Cupos limitados · Precio de lanzamiento
          </span>

          <h2 className="font-display mt-6 text-3xl font-semibold leading-tight text-white sm:text-4xl" data-id="element-18" data-mp="5uo17g3dp5kg">
            Ya es hora de que hagas lo que tanto te gusta y lo conviertas en
            dinero
          </h2>
        </Reveal>

        <Reveal delay={0.1} data-id="element-19" data-mp="1hcyxocn32u64">
          <ul className="mx-auto mt-10 grid max-w-xl gap-3 text-left sm:grid-cols-2" data-id="element-20" data-mp="172np3mf9r7v6">
            {logros.map(l => <li key={l} className="flex items-start gap-2 text-white/85" data-id="element-21" data-mp="1c0615lol237e">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#f4d160]" data-id="element-22" data-mp="1g2asgdrk6nqv" />
                {l}
              </li>)}
          </ul>
        </Reveal>

        <Reveal delay={0.15} data-id="element-23" data-mp="1kzsynwe6yov6">
          <a href="https://curso-de-decoracion-con-globos-para-cumpleanos-y-eventos.impultienda.ar/checkout" className="mt-12 inline-flex items-center justify-center rounded-full bg-[#ec4899] px-10 py-4 text-base font-semibold text-white shadow-lg shadow-[#ec4899]/40 transition hover:bg-[#db2777] hover:shadow-xl" data-id="element-24" data-mp="oc6aelr9ucst">
            QUIERO INSCRIBIRME AHORA
          </a>

          <p className="mt-6 flex items-center justify-center gap-2 text-sm text-white/70" data-id="element-25" data-mp="4o701c0md7nx">
            <ShieldCheckIcon className="h-5 w-5 text-[#f4d160]" data-id="element-26" data-mp="9mgrbbj83o49" />
            7 días de garantía — sin preguntas
          </p>
        </Reveal>
      </div>
    </section>;
}